import { useContext } from 'react'
import { CFDUploadsContext } from '~/hooks/contexts/CFDUploadsContext'

export const useCFDUploadsContext = () => {
  const value = useContext(CFDUploadsContext)
  if (!value) throw new Error('Must use useCFDUploadsContext within provider')
  return value
}
